/** Accent of the new configurator UX: the same purple as the Button "purple" variant. */
export const ACCENT = {
  iconTile: "bg-[#51479e]/10 text-[#51479e]",
  selectedItem: "font-semibold text-[#51479e]",
  activeTab: "data-[state=active]:border-[#51479e] data-[state=active]:text-[#51479e]",
  focusRing: "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#51479e]/40",
  semiActiveTile: "border-[#51479e]/40 text-[#51479e]/80",
  /** Bar on the rail's outer edge marking the open panel */
  railIndicator: "before:absolute before:-left-[5px] before:top-1.5 before:bottom-1.5 before:w-[3px] before:rounded-r before:bg-[#51479e]",
}
